import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../api/client';
import { toast } from '../lib/toast';
import { BOT_LABELS } from '../constants/bots';

export default function BotAccessForm({ domainId, onChange }) {
  const qc = useQueryClient();
  const botsQuery = useQuery({
    queryKey: ['bot-access', domainId],
    queryFn: () =>
      api.get(`/api/domains/${domainId}/bot-access`).then((r) => r.data.allowed_bots),
    enabled: Boolean(domainId),
  });

  const botsMutation = useMutation({
    mutationFn: (next) =>
      api
        .put(`/api/domains/${domainId}/bot-access`, { bots: next })
        .then((r) => r.data.allowed_bots),
    onSuccess: (next) => {
      qc.setQueryData(['bot-access', domainId], next);
      toast.success('Bot access updated');
      onChange?.();
    },
    onError: (err) => toast.error(err, 'Could not update bot access'),
  });

  if (!botsQuery.data) {
    return <div className="text-sm text-ink-400">Loading bot access…</div>;
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
      {Object.entries(BOT_LABELS).map(([botId, label]) => (
        <label
          key={botId}
          className="flex items-center gap-2 text-sm border border-gray-100 rounded-lg px-3 py-2 hover:border-brand-200 hover:bg-brand-50/30 transition-colors cursor-pointer"
        >
          <input
            type="checkbox"
            checked={botsQuery.data[botId] !== false}
            onChange={(e) =>
              botsMutation.mutate({ ...botsQuery.data, [botId]: e.target.checked })
            }
            className="h-4 w-4 rounded border-gray-300 text-brand-600 focus:ring-brand-500/30"
          />
          <span>{label}</span>
        </label>
      ))}
    </div>
  );
}
